// extracted by mini-css-extract-plugin
module.exports = {"page":"ApplyList_page__3rwnX","subBtnStyle":"ApplyList_subBtnStyle__gr-Qn","inputStyle":"ApplyList_inputStyle__2ZE0C"};